import type { SupabaseClient } from '@supabase/supabase-js';
import {
  createSupabaseAppClient,
  registerSupabase,
} from '@sizilianer/core/supabaseFactory';
import type { Database } from '@sizilianer/core/types/database';

/**
 * Web-Boot des Supabase-Clients (Phase 0.6): dünne Hülle über der
 * Factory in @sizilianer/core. Die 40+ Importstellen behalten ihren
 * gewohnten Import — nur die Erzeugung ist entkoppelt, damit dieselbe
 * Logik später in der nativen App mit AsyncStorage/ohne URL-Detection
 * laufen kann.
 */

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  // Im Dev: laut, in Prod: erst zur Laufzeit auffallend
  if (import.meta.env.DEV) {
    console.error(
      '[supabase] Missing env vars: VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY. ' +
      'Check .env.local (local) or Vercel Environment Variables (prod).',
    );
  }
}

export const supabase: SupabaseClient<Database> = createSupabaseAppClient<Database>({
  url: url ?? 'https://placeholder.supabase.co',
  anonKey: anonKey ?? 'placeholder-anon-key',
  clientInfo: 'die-sizilianer-web',
  auth: {
    // Browser-Default-Storage (localStorage) bewusst nicht überschrieben.
    detectSessionInUrl: true,
    flowType: 'pkce',
  },
});

registerSupabase(supabase);

/**
 * Convenience-Re-Exports für TypeScript-Consumer.
 */
export type { Database } from '@sizilianer/core/types/database';
